import { render, staticRenderFns } from "./auditScores.vue?vue&type=template&id=01705d7d&scoped=true"
import script from "./auditScores.vue?vue&type=script&lang=js"
export * from "./auditScores.vue?vue&type=script&lang=js"
import style0 from "./auditScores.vue?vue&type=style&index=0&id=01705d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01705d7d",
  null
  
)

export default component.exports